import React, { useEffect, useState } from 'react';
import Date from '../Inputs/Date';
import Text from '../Inputs/Text';
import File from '../Inputs/File';
import TextArea from '../Inputs/TextArea';
import Select from '../Inputs/Select';
import Checkbox from '../Inputs/Checkbox';
import Radio from '../Inputs/Radio';
import PhoneNumber from '../Inputs/PhoneNumber';
import Birthday from '../Inputs/Birthday';
import Profession from '../Inputs/Profession';
import Country from '../Inputs/Country';
import NumericId from '../Inputs/NumericId';
import PhoneNumberLocal from '../Inputs/PhoneNumberLocal';
import CRM from "../Inputs/CRM";
import EffectsCursos from './EffectsCursos';

const brazilianStates = [
    { codigo: 'AC', valor: 'Acre' },
    { codigo: 'AL', valor: 'Alagoas' },
    { codigo: 'AP', valor: 'Amapá' },
    { codigo: 'AM', valor: 'Amazonas' },
    { codigo: 'BA', valor: 'Bahia' },
    { codigo: 'CE', valor: 'Ceará' },
    { codigo: 'DF', valor: 'Distrito Federal' },
    { codigo: 'ES', valor: 'Espírito Santo' },
    { codigo: 'GO', valor: 'Goiás' },
    { codigo: 'MA', valor: 'Maranhão' },
    { codigo: 'MT', valor: 'Mato Grosso' },
    { codigo: 'MS', valor: 'Mato Grosso do Sul' },
    { codigo: 'MG', valor: 'Minas Gerais' },
    { codigo: 'PA', valor: 'Pará' },
    { codigo: 'PB', valor: 'Paraíba' },
    { codigo: 'PR', valor: 'Paraná' },
    { codigo: 'PE', valor: 'Pernambuco' },
    { codigo: 'PI', valor: 'Piauí' },
    { codigo: 'RJ', valor: 'Rio de Janeiro' },
    { codigo: 'RN', valor: 'Rio Grande do Norte' },
    { codigo: 'RS', valor: 'Rio Grande do Sul' },
    { codigo: 'RO', valor: 'Rondônia' },
    { codigo: 'RR', valor: 'Roraima' },
    { codigo: 'SC', valor: 'Santa Catarina' },
    { codigo: 'SP', valor: 'São Paulo' },
    { codigo: 'SE', valor: 'Sergipe' },
    { codigo: 'TO', valor: 'Tocantins' },
];

export default function CustomFields({
    validStatus,
    customData,
    customFields,
    professionData,
    countryData,
    confirmInput,
    confirmInputPhone,
    confirmOption,
    setPopupWarning,
    registerData,
    setRegisterData,
    text,
    layout,
    emailResponse,
    mdiId
}) {
    const {registerCustomData,setRegisterCustomData} = customData
    const [inputs, setInputs] = useState(showInputs(registerCustomData, customFields));
    const [uf, setUf] = useState("")
    const [crmValue, setCrmValue] = useState("")
    const [isBrazilian, setIsBrazilian] = useState(true);

    function AddDataField(input, value, type) {
        const field = type?input.slug+type:input.slug;
        let newData = registerCustomData;
        newData[field] = value
        setRegisterCustomData(newData);
        setInputs(showInputs(newData,customFields))
    }
    function showInputs(newData, customFields) {

        const data = customFields?customFields.filter(input=>{
            const conditionField = input.condicao?input.condicao[0]:""
            const condition = input.condicao?input.condicao[1]:""

            return (input.condicao&&newData[conditionField]===condition)||!input.condicao

        }):""
        return data
    }

    function AddDataCheckbox(input, target) {
        if(registerCustomData[input.slug]){
            if(target.checked){
                const newData = [...registerCustomData[input.slug], target.value]
                AddDataField(input,newData)
            }else {
                const newData = registerCustomData[input.slug].filter(option=>{
                    return option!==target.value
                })
                AddDataField(input,newData)
            }
        }else{
            AddDataField(input,[target.value])
        }
    }

    function uploadFile(input, element) {
       //    4080000 ~ 3.9mb
       /*if(element.files[0].size>4080000){
            element.value = ""
            setPopupWarning(text.uploadExcedeLimite)
       }else */
       
       AddDataField(input, element.files[0])
     
    }

    function validateCRM(input, value, selectedUf) {
        let crmToValidate = value || crmValue;
        const ufToValidate = selectedUf || uf;

        if(!crmToValidate || !ufToValidate){
            return;
        }

        if(registerData.name === undefined || registerData.surname === undefined){
            return;
        }

        crmToValidate = crmToValidate.replace(/\D/g, '');
        AddDataField(input, crmToValidate+"/"+ufToValidate)
    }

    function handleUfChange(input, selectedUf) {
        setUf(selectedUf);
        if(crmValue && selectedUf) {
            validateCRM(input, crmValue, selectedUf);
        }
    }

    function handleCrmChange(input, value) {
        setCrmValue(value);
        const crmToValidate = value.replace(/\D/g, '');
        AddDataField(input, crmToValidate+"/"+uf)
    }

    function handleCrmBlur(input, value) {
        if(input.obrigatorio) {
            const target = document.getElementById("crm");
            if(target) confirmInput(target);
        }
        if(uf && value) {
            validateCRM(input, value, uf);
        }
    }


    if(mdiId === '774') // Effect Cursos
    {
        return (
            <EffectsCursos
                validStatus={validStatus}
                inputs={inputs}
                isBrazilian={isBrazilian}
                setIsBrazilian={setIsBrazilian}
                uf={uf}
                crmValue={crmValue}
                AddDataField={AddDataField}
                handleCrmChange={handleCrmChange}
                handleCrmBlur={handleCrmBlur}
                handleUfChange={handleUfChange}
                confirmOption={confirmOption}
                confirmInput={confirmInput}
                uploadFile={uploadFile}
                text={text}
                brazilianStates={brazilianStates}
                registerData={registerData}
                setRegisterData={setRegisterData}
                emailResponse={emailResponse}
            />
        );
    }
    
    return (validStatus) ? inputs?.map((input, index) => {
                return parseInt(input.grp_id) > 0 && registerData.grupos && registerData.grupos.length > 0 && registerData.grupos.includes(input.grp_id) ? <React.Fragment key={input.slug+index}></React.Fragment> : (  
                   input.tipo==="date"?
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <Date  
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmInput={confirmInput}
                                  registerCustomData={registerCustomData}
                                  />
                          </label>
                      : input.tipo==="text" ?
                      <React.Fragment key={input.slug+index}>
                        {input.tipo==="text" && input.slug==="crm" && input.validate && emailResponse === 2 ? <>
                            <label key={'name'+index} className="midsize" htmlFor="name"><p>{text.nome} <span>*</span></p> 
                                <input 
                                    name={text.nome} 
                                    placeholder={text.nome}
                                    type="text" 
                                    onChange={e => setRegisterData({...registerData, name:e.target.value})} 
                                    onBlur={e => confirmInput(e.target)} 
                                    value={registerData.name || ''}
                                    required
                                    />
                            </label>
                            <label key={'surname'+index} className="midsize" htmlFor="surname"><p>{text.sobrenome} <span>*</span></p> 
                                <input 
                                    name={text.sobrenome}
                                    placeholder={text.sobrenome}
                                    type="text" 
                                    onChange={e => setRegisterData({...registerData, surname:e.target.value})}
                                    onBlur={e => confirmInput(e.target)} 
                                    value={registerData.surname || ''}
                                    required
                                    />
                            </label>
                        </> : <></>}
                          <label className={input.slug==="crm" && input.validate ? "fullsize" : "midsize"} key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                            {
                                input.slug==="crm" && input.validate ?
                                    <div className="ValidateCRM">
                                        <CRM
                                            input={input}
                                            AddDataField={(inp, val) => handleCrmChange(inp, val)}
                                            confirmInput={confirmInput}
                                            crmValue={crmValue}
                                            validate={(inp, val) => handleCrmBlur(inp, val)}
                                            />
                                        <select
                                            name="uf"
                                            id="uf"
                                            onChange={e => handleUfChange(input, e.target.value)}
                                            value={uf}
                                            required={input.obrigatorio}
                                        >
                                            <option value="" disabled>{text.crmEstado}</option>
                                            {brazilianStates.map(state=>{
                                                return <option key={state.codigo} value={state.codigo}>{state.valor}</option>
                                            })}
                                        </select>
                                    </div>
                                :
                                  <Text
                                      input={input}
                                      AddDataField={AddDataField}
                                      confirmInput={confirmInput}
                                      registerCustomData={registerCustomData}
                                      />
                            }
                          </label>
                      </React.Fragment>

                      :input.tipo==="binary"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <File  
                                  input={input}
                                  uploadFile={uploadFile}
                                  confirmInput={confirmInput}
                                  />
                          </label>
                      :input.tipo==="longtext"?
                          <label className="input_fullSize midsize" key={input.slug+index}><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <TextArea  
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmInput={confirmInput}
                                  registerCustomData={registerCustomData}
                                  />
                          </label>
                      :input.tipo==="dropdown"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <Select  
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmInput={confirmInput}
                                  />
                          </label>
                      :input.tipo==="check"?
              
                          <label className="midsize" key={input.slug+index}><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <Checkbox  
                                  input={input}
                                  AddDataCheckbox={AddDataCheckbox}
                                  confirmOption={confirmOption}
                                  />
                          </label>
                      :input.tipo==="radio"?
              
                          <label className="midsize" key={input.slug+index}><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <Radio  
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmOption={confirmOption}
                                  />
                          </label>    
                      :input.tipo==="phone"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                                  <PhoneNumber
                                      input={input}
                                      AddDataField={AddDataField}
                                      confirmInput={confirmInput}
                                      confirmInputPhone={confirmInputPhone}
                                      registerCustomData={registerCustomData}
                                      registerData={registerData}
                                      defaultCountry={layout.idioma == 'ptbr' ? 'BR' : 'US'}
                                      />
                              </label>
                      :input.tipo==="phonelocal"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <PhoneNumberLocal
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmInput={confirmInput}
                                  registerCustomData={registerCustomData}
                                  registerData={registerData}
                                  />
                          </label>
                      :input.tipo==="nascimento"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <Birthday
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmInput={confirmInput}
                                  registerData={registerData}
                                  text={text}
                                  />
                          </label>
                      :input.tipo==="profissao"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                              <Profession  
                                  input={input}
                                  AddDataField={AddDataField}
                                  confirmInput={confirmInput}
                                  professionData={professionData}
                                  />
                          </label>
                      :input.tipo==="pais"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                          <Country  
                              input={input}
                              AddDataField={AddDataField}
                              confirmInput={confirmInput}
                              countryData={countryData}
                              />
                          </label>
                      :input.tipo==="idnumerico"?
              
                          <label className="midsize" key={input.slug+index} ><p>{input.nome} <span>{input.obrigatorio?"*":""}</span> </p>
                          <NumericId  
                              input={input}
                              AddDataField={AddDataField}
                              confirmInput={confirmInput}
                              registerCustomData={registerCustomData}
                              />
                          </label>
                      :<></>
            ) 
        }):<></>  
}       
        
